(function(){
  function qs(s,c){return (c||document).querySelector(s)}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}

  // Header / mega menu / mobile menu
  document.addEventListener('click',function(e){
    var trigger=e.target.closest('.pure-nav-trigger');
    if(trigger){
      var item=trigger.closest('.pure-nav-item');
      qsa('.pure-nav-item.open').forEach(function(x){if(x!==item)x.classList.remove('open')});
      item.classList.toggle('open');
      trigger.setAttribute('aria-expanded',item.classList.contains('open')?'true':'false');
      e.preventDefault(); return;
    }
    if(!e.target.closest('.pure-nav-item')) qsa('.pure-nav-item.open').forEach(function(x){x.classList.remove('open')});
  });
  var mobileToggle=qs('.pure-mobile-toggle'), mobileMenu=qs('#PureMobileMenu');
  if(mobileToggle&&mobileMenu){mobileToggle.addEventListener('click',function(){var open=mobileMenu.hasAttribute('hidden'); if(open) mobileMenu.removeAttribute('hidden'); else mobileMenu.setAttribute('hidden',''); mobileToggle.setAttribute('aria-expanded',open?'true':'false');});}

  // Cart count stays current after navigation or AJAX changes.
  function updateCartCount(){fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(cart){qsa('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count||0})}).catch(function(){});}
  updateCartCount();

  // Product variant selection.
  var form=qs('#PureProductForm');
  if(form){
    var variantSelect=qs('.pure-variant-select',form), variants=[];
    try{variants=JSON.parse(form.getAttribute('data-variants')||'[]')}catch(e){}
    var variantData=qs('[data-variant-json]',form); if(variantData){try{variants=JSON.parse(variantData.textContent||'[]')}catch(e){}}
    var optionInputs=qsa('.pure-option-list input',form);
    function syncVariant(){
      if(!variantSelect||!variants.length)return;
      var selected=optionInputs.map(function(i){return i.checked?i.value:null}).filter(Boolean);
      if(!selected.length)return;
      var match=variants.find(function(v){return v.options && v.options.every(function(val,i){return val===selected[i]})});
      if(!match)return;
      var option=Array.prototype.find.call(variantSelect.options,function(o){return String(o.value)===String(match.id)}); if(option){variantSelect.value=match.id;}
      var add=qs('.pure-add',form), price=qs('[data-add-price]',form);
      if(price&&match.price!=null){price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(match.price/100)}
      if(add)add.disabled=!match.available;
    }
    optionInputs.forEach(function(i){i.addEventListener('change',syncVariant)});
    if(variantSelect)variantSelect.addEventListener('change',function(){var selected=variants.find(function(v){return String(v.id)===String(variantSelect.value)});if(!selected)return; optionInputs.forEach(function(i){var idx=i.closest('fieldset')?Array.prototype.indexOf.call(form.querySelectorAll('fieldset'),i.closest('fieldset')):0;i.checked=selected.options&&selected.options[idx]===i.value;});});
    qsa('[data-qty-minus],[data-qty-plus]',form).forEach(function(btn){btn.addEventListener('click',function(){var input=qs('input[type=number]',btn.parentElement);if(!input)return;var v=Math.max(1,parseInt(input.value||1,10)+(btn.hasAttribute('data-qty-plus')?1:-1));input.value=v;})});
    if(variants.length)syncVariant();
    form.addEventListener('submit',function(e){
      if(e.submitter&&e.submitter.name==='add'&&e.submitter.disabled){e.preventDefault();return;}
      if(!window.fetch)return;
      e.preventDefault();
      var fd=new FormData(form);
      fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd}).then(function(r){if(!r.ok)throw new Error('add failed');return r.json()}).then(function(){updateCartCount();window.location.href='/cart'}).catch(function(){form.submit()});
    });
  }

  // Cart line quantity helpers: buttons update the associated input; Shopify handles the submit.
  qsa('[data-cart-minus],[data-cart-plus]').forEach(function(btn){btn.addEventListener('click',function(){var row=btn.closest('.pure-cart-line');var input=qs('input[name="updates[]"]',row);if(!input)return;var v=Math.max(0,parseInt(input.value||0,10)+(btn.hasAttribute('data-cart-plus')?1:-1));input.value=v;})});
})();
